import classes from "./PlayerItem.module.css";
import TeamList from "./TeamList";
import {
  Card,
  CardContent,
  IconButton,
  Select,
  MenuItem,
  Box,
} from "@mui/material";
import EditIcon from "@mui/icons-material/Edit";
import { useState } from "react";

function ChukkerItem(props) {
  const [isEditing, setIsEditing] = useState(false);
  const [selectedDivision, setSelectedDivision] = useState(
    props.chukkerDetails && props.chukkerDetails[props.id]
      ? props.chukkerDetails[props.id]["division_name"]
      : ""
  );

  const handleDivisionChange = (event) => {
    const newDivision = event.target.value;
    setSelectedDivision(newDivision);
    props.setChukkerDetails((prev) => ({
      ...prev,
      [props.id]: {
        ...prev[props.id],
        division_name: newDivision,
      },
    }));
    setIsEditing(false);
  };

  return (
    <Card
      sx={{
        mx: -1,
        boxShadow: 0,
        backgroundColor: "transparent",
      }}
      data-testid={"chukker-" + props.id}
    >
      <CardContent sx={{ p: props.minimalMode ? 0 : 1, "&:last-child": { pb: props.minimalMode ? 0 : 1 } }}>
        {!props.minimalMode && (
          <Box sx={{ display: "flex", justifyContent: "center", mb: 1 }}>
            <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
              <h3 className={classes.contenth}>
                {props.id.startsWith("-") ? "Bench" : "Chukker " + props.id}
              </h3>
            {props.gameDivisions && props.gameDivisions.length > 0 && !isEditing && (
              <Box sx={{ display: "flex", alignItems: "center", gap: 0.5 }}>
                {props.chukkerDetails[props.id]["division_name"] && (
                  <span>{props.chukkerDetails[props.id]["division_name"]}</span>
                )}
                <IconButton
                  size="small"
                  onClick={() => setIsEditing(true)}
                  sx={{ ml: 0.5 }}
                >
                  <EditIcon fontSize="small" />
                </IconButton>
              </Box>
            )}
            {isEditing && (
              <Select
                value={selectedDivision}
                onChange={handleDivisionChange}
                size="small"
                sx={{ minWidth: 120 }}
              >
                <MenuItem value="">None</MenuItem>
                {props.gameDivisions.map((division) => (
                  <MenuItem key={division} value={division}>
                    {division}
                  </MenuItem>
                ))}
              </Select>
            )}
          </Box>
        </Box>
        )}
        {!props.id.startsWith("-") && (
          <TeamList
            managerMode={props.managerMode}
            teamList={props.teams}
            chukkerId={props.id}
            referencePlayer={props.referencePlayer}
            useUSPARating={props.useUSPARating}
            isBench={false}
            proColorMapping={props.proColorMapping}
            betaMode={props.betaMode}
            chukkerDetails={props.chukkerDetails}
            setChukkerDetails={props.setChukkerDetails}
            useEnhancedPlayerList={props.useEnhancedPlayerList}
            onQuickAssign={props.onQuickAssign}
            getAvailableTargets={props.getAvailableTargets}
          />
        )}
      </CardContent>
    </Card>
  );
}

export default ChukkerItem;
